/**
 * Default benefit image presets matching S3 CDN URLs.
 * Image IDs correspond to preset IDs in themePresets.js for seamless mapping.
 */
export const BENEFIT_DEFAULT_IMAGES = [
  {
    id: 'classic_red',
    label: 'Classic Red',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Classic+Red.png',
  },
  {
    id: 'navy_professional',
    label: 'Navy Professional',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Navy+Professional.png',
  },
  {
    id: 'forest_executive',
    label: 'Forest Executive',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Forest+Executive.png',
  },
  {
    id: 'slate_modern',
    label: 'Slate Modern',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Slate+Modern.png',
  },
  {
    id: 'amber_luxury',
    label: 'Amber Luxury',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Amber+Luxury.png',
  },
  {
    id: 'violet_creative',
    label: 'Violet Creative',
    image_url: 'https://s3.ap-southeast-1.amazonaws.com/cdn-member.omnihotelier.com/images/Violet+Creative.png',
  },
];
